import { faPaintbrush } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tag } from '@frontend/app/refresh-components';
import { Button } from '@frontend/shadcn/components/ui/button';
import { Card, CardContent } from '@frontend/shadcn/components/ui/card';
import React from 'react';

export const ApplicationSnapshot = () => {
  return (
    <Card className="border border-border shadow-md">
      <CardContent className="p-4 h-[740px] w-full">
        <div className="flex flex-col h-full">
          <div className="flex flex-col gap-2">
            <Tag
              label="Published to Creator Marketplace"
              bgColor="bg-green-2"
              textColor="text-green-6"
              className="w-fit"
            />
            <div className="flex flex-col gap-0">
              <h3 className="text-lg font-medium text-grey-6 m-0">2025 Product Launch</h3>
              <p className="text-sm text-grey-4 m-0">Now-Dec 31, 2025</p>
            </div>
          </div>

          {/* Image container taking remaining height */}
          <div className="flex-1 flex items-center justify-center">
            <img
              src="https://storage.googleapis.com/aspirex-static-files/onboarding-template/amplifyTemplate.png"
              alt="amplifyTemplate"
              className="w-[280px] h-[560px] object-contain"
            />
          </div>

          <div className="mt-auto">
            <Button variant="primary" size="sm" className="h-8 gap-2 w-fit" onClick={() => undefined}>
              <FontAwesomeIcon icon={faPaintbrush} />
              Customize
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
